// import React, { useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import Lottie from "lottie-react";
// import loaderAnimation from "../animations/loader.json"; // ✅ animation
// import { toast } from "react-toastify";

// import "../css/ProgressPage.css";

// const ProgressPage = () => {
//   const navigate = useNavigate();

 
//   return (
//     <div className="progress-wrapper">
//       <div className="progress-card">
//         <Lottie
//           animationData={loaderAnimation}
//           loop={true}
//           className="progress-loader"
//         />
//         <h2 className="progress-title">Subscription in progress</h2>
       
//       </div>
//     </div>
//   );
// };

// export default ProgressPage;


import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Lottie from "lottie-react";
import loaderAnimation from "../animations/loader.json";
import { toast } from "react-toastify";
import axios from "axios";

import { baseUrlApi, checkApi } from "../api/api"; // Assuming you export it from there
import "../css/ProgressPage.css";

const ProgressPage = () => {
  const navigate = useNavigate();
      const params = new URLSearchParams(window.location.search);
      const msisdn = localStorage.getItem("msisdn");

  const checkUser = async () => {
  // const msisdn = localStorage.getItem("msisdn"); // or get from props/context
  if (!msisdn) {
    toast.error("MSISDN not found!");
    return;
  }
    try {
      const payload = { msisdn: msisdn.trim() };
      const response = await axios.post(`${baseUrlApi}${checkApi}`,payload);
      const { accessGranted, message } = response.data;

      if (accessGranted) {
        toast.success("Access granted!");
        navigate("/home");
      } else {
        console.log("Waiting for subscription...", message);
        toast.error(message);
        setTimeout(()=>{
          navigate('/subscribe')
        },3000)
        
      }
    } catch (error) {
      console.error("API error:", error);
      toast.error("Error checking subscription.");
      navigate('/subscribe')
    }
  }


useEffect(()=>{
  // checkUser()

  // setTimeout(()=>{
  //   navigate('/home')
  // },3000)
},[])

  return (
    <div className="cptpl_page progress-wrapper">
      <div className="progress-card">
        <Lottie
          animationData={loaderAnimation}
          loop={true}
          className="progress-loader"
        />
        <h2 className="progress-title">Subscription in progress</h2>
      </div>
    </div>
  );
};

export default ProgressPage;
